import { useEffect, useLayoutEffect } from 'react';

import { startInitialBottomAnchor } from './startInitialBottomAnchor';
import type { Args } from './types';
import { useInitialBottomAnchorRefs } from './useInitialBottomAnchorRefs';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

// The treatment uses layout timing so the initial top-of-history position is
// corrected before the browser paints the opened chat.
export const useLayoutInitialBottomAnchor = (args: Args): void => {
	const {
		enabled,
		totalSize,
		conversationId,
		containerRef,
		scrollToBottomGeneration,
		onInitialAnchorApplied,
	} = args;
	const refs = useInitialBottomAnchorRefs();
	useIsomorphicLayoutEffect(
		() =>
			startInitialBottomAnchor(
				{
					enabled,
					totalSize,
					conversationId,
					containerRef,
					scrollToBottomGeneration,
					onInitialAnchorApplied,
				},
				refs,
			),
		[
			enabled,
			totalSize,
			conversationId,
			containerRef,
			scrollToBottomGeneration,
			onInitialAnchorApplied,
			refs,
		],
	);
};
